import type { InsightAxisType, InsightHint } from '@/types/insights';

export type InsightSample = {
  key: string;
  heading: string;
  axis: InsightAxisType;
  topic: { text: string };
  hint: InsightHint;
};

export const insightSamples: InsightSample[] = [
  {
    key: 'power-semiconductor',
    heading: 'サンプル１： パワー半導体の研究開発担当の場合',
    axis: 'personal',
    topic: {
      text: 'EVの走行距離を伸ばすため、電気のムダが少ない次世代の半導体を採用する自動車メーカーが増えていることが報じられました。部品メーカー各社も、量産に向けた開発を急いでいます。',
    },
    hint: {
      id: 0,
      uuid: 'sample-1',
      focus_point:
        '次世代の半導体がEVに広がる中で、次に取り組むべき課題は、さらに電気のムダを減らすことでしょうか。それとも、熱に強くすることでしょうか。',
      focus_point_reason:
        '次世代の半導体はEVでの採用が進み、各社が性能を高める競争を続けています。研究開発をご担当されている立場から見ると、次にどの性能を伸ばすかが、今後の開発の方向性を左右すると考えました。',
      hypothesis:
        '半導体は小さく高性能になるほど、内部に熱がこもりやすくなります。そのため、これからは電気のムダを減らすことよりも、熱に強くすることが大きな課題になると考えています。',
      hypothesis_reasons: [
        {
          id: 0,
          text: '電気のムダはすでに大きく減っており、製品ごとの差は熱への強さに表れやすくなっていると考えました。熱に強い半導体であれば、冷やすための部品を減らせるため、車体の軽量化やコスト削減にもつながります。',
          sources: [],
        },
      ],
      recommended_actions: [
        {
          id: 0,
          uuid: 'sample-1-action-1',
          label: '半導体の熱を逃がす技術を調べる',
          agent_type: 'tech_exploration',
          prefill_prompt_generation_status: 'processed',
        },
        {
          id: 0,
          uuid: 'sample-1-action-2',
          label: '次世代の半導体の普及で次に生まれる課題をAIと壁打ちする',
          agent_type: 'survey',
          prefill_prompt_generation_status: 'processed',
        },
      ],
      saved: false,
      topic: null,
    },
  },
  {
    key: 'production-engineering',
    heading: 'サンプル２： 自動車部品メーカーの生産技術担当の場合',
    axis: 'organization',
    topic: {
      text: '社内で注目が集まっている、物流倉庫での作業動作解析の動向です。作業者の動きをカメラ映像からAIで解析して作業負荷や無駄な動作を可視化し、作業手順の見直しや新人教育に活かす取り組みが広がっています。',
    },
    hint: {
      id: 0,
      uuid: 'sample-2',
      focus_point:
        '社内で関心が高まっている倉庫の作業動作解析を組立ラインに持ち込むなら、作業者ごとのばらつきが大きい段取り替えと、品質に直結する検査工程のどちらを起点に置くべきでしょうか。',
      focus_point_reason:
        '社内で注目が集まっている倉庫の作業動作解析は、人の動きを可視化して、作業手順の見直しや新人教育に活かす取り組みです。自動車部品の生産技術という業務から、同じ仕組みを組立ラインに転用できる余地があり、どの工程から適用するかが最初の判断になると考えました。',
      hypothesis:
        '段取り替えは手順が属人化しやすく、熟練者と新人の動作の差が大きい工程です。動作を可視化して熟練者の手順を標準化すれば、段取り時間の短縮と教育期間の短縮を同時に狙えると考えられます。',
      hypothesis_reasons: [
        {
          id: 0,
          text: '倉庫での活用は、手順の見直しと教育に効いているとされています。組立ラインでは、段取り替えが手順の属人化と作業者ごとの差が出やすい工程です。手順の標準化と教育という同じ効果を得やすいため、検査工程より先に試す価値が高いと判断しました。',
          sources: [],
        },
      ],
      recommended_actions: [
        {
          id: 0,
          uuid: 'sample-2-action-1',
          label: '段取り替え作業のばらつきを抑える改善策を探す',
          agent_type: 'tech_exploration',
          prefill_prompt_generation_status: 'processed',
        },
        {
          id: 0,
          uuid: 'sample-2-action-2',
          label: '段取り替えへの動作解析の適用範囲をAIと壁打ちする',
          agent_type: 'survey',
          prefill_prompt_generation_status: 'processed',
        },
      ],
      saved: false,
      topic: null,
    },
  },
];
